export const environment = {
  baseUrl: 'https://www9.dinkclub.hk',
  production: false,
  gqlBaseUrl: 'https://api9.dinkclub.hk/graphql',
  paymentGatewayEndpoint: 'https://api9.dinkclub.hk/pay/kpay/sale/',
  publicImageBaseUrl: 'https://api9.dinkclub.hk/filebase/',
  availableLangs: ['en', 'tc', 'sc'],
  defaultLang: 'en',
  isOnline: true,
  'x-channel': 'web',
  isLocal: false,
  showTestBar: true,
  cloudflareRecaptchaSiteKey: '0x4AAAAAAAZK8bJlm7OyJ79Q',
  default: {
    areaCode: '852',
    homePageNewsPerPage: 10,
    defaultNationalityId: 133,
  },
  sqlDateFormat: 'YYYY-MM-DD HH:mm:ss',
};
